<ng-container *transloco="let t">
  <div class="header-wrapper">
    <mzic-header></mzic-header>
  </div>

  <!-- Hero Section -->
  <section class="hero-section">
    <div class="section-container">
      <div class="hero-content">
        <p class="hero-subtitle-small">
          {{ t('marketLang.hero.subtitle_small') }}
        </p>
        <h1 class="hero-title">
          {{ t('marketLang.hero.title') }}
        </h1>
        <p class="hero-description">
          {{ t('marketLang.hero.description') }}
          <br />
        </p>
      </div>

      <!-- Accordion Section -->
      <div class="accordion-wrapper">
        <mzic-accordion
          #industrySizeAccordion
          [title]="'marketLang.accordions.industrySize.title'"
          [isOpen]="activeAccordion === 'industrySize'"
          (toggle)="toggleAccordion('industrySize')">
          <p>{{ t('marketLang.accordions.industrySize.content.intro') }}</p>

          <h3 class="accordion-subtitle">
            {{ t('marketLang.accordions.industrySize.content.brazilSubtitle') }}
          </h3>

          <p>{{ t('marketLang.accordions.industrySize.content.paragraph1') }}</p>
          <p>{{ t('marketLang.accordions.industrySize.content.paragraph2') }}</p>
          <p>{{ t('marketLang.accordions.industrySize.content.paragraph3') }}</p>
        </mzic-accordion>

        <mzic-accordion
          #howMusicGeneratesRevenueAccordion
          [title]="'marketLang.accordions.howMusicGeneratesRevenue.title'"
          [isOpen]="activeAccordion === 'howMusicGeneratesRevenue'"
          (toggle)="toggleAccordion('howMusicGeneratesRevenue')">
          <p>
            {{
              t('marketLang.accordions.howMusicGeneratesRevenue.content.paragraph1')
            }}
          </p>
          <p>
            {{
              t('marketLang.accordions.howMusicGeneratesRevenue.content.paragraph2')
            }}
          </p>
          <p>
            {{
              t('marketLang.accordions.howMusicGeneratesRevenue.content.paragraph3')
            }}
          </p>
          <p>
            {{
              t('marketLang.accordions.howMusicGeneratesRevenue.content.paragraph4')
            }}
          </p>

          <div class="revenue-carousel-wrapper">
            <div class="carousel-container" #carouselContainer>
              <div class="carousel-track">
                <div
                  class="revenue-card"
                  *ngFor="let card of revenueCards; let i = index">
                  <!-- Badges para o primeiro card -->
                  <div class="card-badges" *ngIf="card.type === 'badges' && card.badges">
                    <div
                      class="badge"
                      *ngFor="let badge of card.badges">
                      <img
                        [src]="badge.icon"
                        [alt]="t(badge.textKey)"
                        width="24"
                        height="24" />
                      <span>{{ t(badge.textKey) }}</span>
                    </div>
                  </div>

                  <!-- Ícones grandes para os demais cards -->
                  <div class="card-icons" *ngIf="card.type === 'icons' && card.icons">
                    <div class="large-icon" *ngFor="let icon of card.icons">
                      <img
                        *ngIf="icon"
                        [src]="icon"
                        alt="Icon"
                        width="42"
                        height="42" />
                    </div>
                  </div>

                  <h4 class="card-title">
                    {{
                      t(
                        'marketLang.accordions.howMusicGeneratesRevenue.content.cards.' +
                          card.key +
                          '.title'
                      )
                    }}
                  </h4>
                  <p
                    class="card-description"
                    [innerHTML]="
                      t(
                        'marketLang.accordions.howMusicGeneratesRevenue.content.cards.' +
                          card.key +
                          '.description'
                      )
                    "></p>
                </div>
              </div>
            </div>
            <button
              *ngIf="showRightButton"
              class="carousel-nav-button carousel-nav-button-right"
              (click)="scrollCarousel()"
              aria-label="Navegar para direita">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M9 18L15 12L9 6"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </button>
            <button
              *ngIf="showLeftButton"
              class="carousel-nav-button carousel-nav-button-left"
              (click)="scrollCarouselBack()"
              aria-label="Navegar para esquerda">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M15 18L9 12L15 6"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </button>
          </div>
        </mzic-accordion>

        <mzic-accordion
          #whyInvestInMusicAccordion
          [title]="'marketLang.accordions.whyInvestInMusic.title'"
          [isOpen]="activeAccordion === 'whyInvestInMusic'"
          (toggle)="toggleAccordion('whyInvestInMusic')">
          <!-- Intro -->
          <p>{{ t('marketLang.accordions.whyInvestInMusic.content.intro') }}</p>

          <!-- Subtítulo: Baixa correlação com a economia -->
          <h3 class="accordion-subtitle">
            {{
              t(
                'marketLang.accordions.whyInvestInMusic.content.lowCorrelation.subtitle'
              )
            }}
          </h3>

          <!-- 3 parágrafos sobre baixa correlação -->
          <p>
            {{
              t(
                'marketLang.accordions.whyInvestInMusic.content.lowCorrelation.paragraph1'
              )
            }}
          </p>
          <p>
            {{
              t(
                'marketLang.accordions.whyInvestInMusic.content.lowCorrelation.paragraph2'
              )
            }}
          </p>
          <p>
            {{
              t(
                'marketLang.accordions.whyInvestInMusic.content.lowCorrelation.paragraph3'
              )
            }}
          </p>

          <!-- Subtítulo: Retornos atrativos -->
          <h3 class="accordion-subtitle">
            {{
              t(
                'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.subtitle'
              )
            }}
          </h3>

          <!-- Parágrafo 1: fundos de royalties -->
          <p>
            {{
              t(
                'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.paragraph1'
              )
            }}
          </p>

          <!-- Parágrafo 2: Manda um Oi (com link) -->
          <p>
            Um bom exemplo é a operação
            <a
              [href]="
                'https://' +
                t(
                  'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.paragraph2_link_url'
                )
              "
              target="_blank"
              class="accordion-link">
              {{
                t(
                  'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.paragraph2_link_text'
                )
              }}
            </a>
            , originada pela MZIC e distribuída em parceria ao MB. No cenário
            base, a previsão de rentabilidade é de 20,72% a.a, com a
            possibilidade de chegar a 23,4% a.a em um cenário mais otimista.
          </p>

          <!-- Parágrafo 3: alcance global -->
          <p>
            {{
              t(
                'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.paragraph3'
              )
            }}
          </p>

          <!-- Parágrafo 4: Gusttavo Lima -->
          <p>
            {{
              t(
                'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.paragraph4'
              )
            }}
          </p>

          <!-- Parágrafo 5: Primary Wave e Adaggio (com 2 links) -->
          <p>
            E esse interesse não é pontual - é institucional. A Primary Wave
            <a
              [href]="
                t(
                  'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.paragraph5_link1_url'
                )
              "
              target="_blank"
              class="accordion-link">
              {{
                t(
                  'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.paragraph5_link1_text'
                )
              }}
            </a>
            em uma transação que valorizou a empresa em ~US$ 100 milhões — sinal
            de que catálogo bom tem fila de comprador. Além disso,
            <a
              [href]="
                t(
                  'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.paragraph5_link2_url'
                )
              "
              target="_blank"
              class="accordion-link">
              {{
                t(
                  'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.paragraph5_link2_text'
                )
              }}
            </a>
            ; segundo seus controladores, a saída entregou ~93% de retorno
            acumulado (~23% a.a.) aos cotistas — um caso nítido de liquidez e
            rentabilidade.
          </p>

          <!-- Parágrafo 6: Top 10 e 4,8 trilhões (com 2 links) -->
          <p>
            Do lado do consumo, o vento continua a favor do retorno. O Brasil já
            figura entre os
            <a
              [href]="
                t(
                  'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.paragraph6_link1_url'
                )
              "
              target="_blank"
              class="accordion-link">
              {{
                t(
                  'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.paragraph6_link1_text'
                )
              }}
            </a>
            em volume de streaming (áudio + vídeo), mas ainda está apenas na 34ª
            posição em participação premium — há espaço para converter usuários
            gratuito em pagantes, elevando o valor de cada play para quem recebe
            os royalties. No mundo, os streams de áudio chegaram ao total de
            <a
              [href]="
                t(
                  'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.paragraph6_link2_url'
                )
              "
              target="_blank"
              class="accordion-link">
              {{
                t(
                  'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.paragraph6_link2_text'
                )
              }}
            </a>
            em 2024 (+14% a.a): o bolo segue crescendo.
          </p>

          <!-- Parágrafo 7: majors (Universal, Warner, Sony - com 3 links) -->
          <p>
            No 'macro' do setor, as majors seguem fortes. A
            <a
              [href]="
                t(
                  'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.paragraph7_link1_url'
                )
              "
              target="_blank"
              class="accordion-link">
              {{
                t(
                  'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.paragraph7_link1_text'
                )
              }}
            </a>
            reportou €5,88 bi de receita no 1º semestre/25 (+6,4% a/a) e margem
            de EBITDA ajustado ~22–23%. A
            <a
              [href]="
                t(
                  'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.paragraph7_link2_url'
                )
              "
              target="_blank"
              class="accordion-link">
              {{
                t(
                  'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.paragraph7_link2_text'
                )
              }}
            </a>
            registrou +9% de receita e OIBDA ajustado +18% no 3º trimestre
            fiscal/25. Já a
            <a
              [href]="
                t(
                  'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.paragraph7_link3_url'
                )
              "
              target="_blank"
              class="accordion-link">
              {{
                t(
                  'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.paragraph7_link3_text'
                )
              }}
            </a>
            fechou 2024 com +14% de receita e lucro operacional recorde de ¥357
            bi. Crescimento e margens saudáveis reforçam a capacidade estrutural
            dos grandes players e sustentam a perspectiva de um futuro sólido e
            próspero para a indústria como um todo.
          </p>

          <!-- Explanations (EBITDA e OIBDA) -->
          <br />
          <p class="accordion-explanation">
            {{
              t(
                'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.explanation1'
              )
            }}
          </p>
          <p class="accordion-explanation">
            {{
              t(
                'marketLang.accordions.whyInvestInMusic.content.attractiveReturns.explanation2'
              )
            }}
          </p>
        </mzic-accordion>
      </div>
    </div>
  </section>

  <!-- Footer -->
  <mzic-footer></mzic-footer>
</ng-container>
